import { render } from "./retailGoodsAdd.vue?vue&type=template&id=37d84b5a"
import script from "./retailGoodsAdd.vue?vue&type=script&lang=js"
export * from "./retailGoodsAdd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__